import { render, staticRenderFns } from "./Posiciones.vue?vue&type=template&id=24898ad3"
import script from "./Posiciones.vue?vue&type=script&setup=true&lang=js"
export * from "./Posiciones.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports